import React, { useMemo } from "react";
import {
  GridActionsCellItem,
  GridActionsCellItemProps,
} from "@mui/x-data-grid-pro";
import { useTypedSelector } from "store";
import { selectProductLineId } from "store/reducers/products/products.selectors";

export type TableSummaryGridAction_OpenProps = Extract<
  GridActionsCellItemProps,
  { showInMenu: true }
> & {
  readonly tableId: string;
};

function buildOpenTableUrl(productLineId: string, tableId: string) {
  if (!productLineId) {
    return "";
  }

  return `/products/${productLineId}/rules-tables?tableId=${encodeURIComponent(
    tableId
  )}`;
}

/** Anchor attrs for menu GridActionsCellItem — supported at runtime. */
function getOpenTableLinkProps(openTableUrl: string) {
  return {
    component: "a" as const,
    href: openTableUrl,
    target: "_blank" as const,
    rel: "noopener noreferrer",
  };
}

export function TableSummaryGridAction_Open({
  tableId,
  disabled,
  ...props
}: TableSummaryGridAction_OpenProps) {
  const productLineId = useTypedSelector(selectProductLineId);

  const openTableUrl = useMemo(
    () => buildOpenTableUrl(productLineId, tableId),
    [productLineId, tableId]
  );

  const hasUrl = !!openTableUrl;

  return (
    <GridActionsCellItem
      {...props}
      showInMenu
      disabled={disabled || !hasUrl}
      {...(hasUrl ? getOpenTableLinkProps(openTableUrl) : {})}
    />
  );
}
